<template>
<div class="evalus">
    <!-- <div class="playModel">
        <el-button type="primary" @click.prevent="seeHealthFx" size="mini">查看个人健康分析</el-button>
    </div> -->
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item.name}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div class="metter" v-if="voteData.length!==0">
      <el-table v-show="lableindex !== 4" :data="voteData" height="480px" border style="width:100%">
        <el-table-column min-width="140px" :label="'名称'" prop="plan_name" show-overflow-tooltip>
          <template slot-scope="scope">
            <span type="primary" size="mini" class="title1deta">{{scope.row.plan_name}}</span>
          </template>
        </el-table-column>

        <el-table-column width="100px" :label="'类型'" align="center" prop="catedicname" show-overflow-tooltip></el-table-column>
        <el-table-column width="90px" :label="'状态'" align="center" prop="timestatus">
          <template slot-scope="scope">
            <span v-if="scope.row.timestatus==1">未开始</span>
            <span v-else-if="scope.row.timestatus==2">进行中</span>
            <span v-else-if="scope.row.timestatus==3">已结束</span>
          </template>
        </el-table-column>
        <el-table-column width="100px" :label="'开始时间'" align="center" prop="begintime">
          <template slot-scope="scope">
            <span>{{scope.row.begintime.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column width="100px" :label="'结束时间'" align="center" prop="endtime">
          <template slot-scope="scope">
            <span>{{scope.row.endtime.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="'操作'"
          width="160"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
            type="primary"
            plain
            size="mini"
            :disabled="scope.row.timestatus!=3"
            @click="handleCreate(scope.row)"
            >查看报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-show="lableindex === 4" :data="voteData" height="440px" border style="width:100%">
        <el-table-column width="180px" label="检测时间" prop="createtime" align="center"></el-table-column>
        <el-table-column width="80px" label="健康状态" prop="score" align="center">
            <template slot-scope="scope">
                <span style="color: green;" v-if="scope.row.state === 0">正常</span>
                <span style="color: red;" v-else-if="scope.row.state === 1">异常</span>
            </template>
        </el-table-column>
        <el-table-column min-width="200px" label="风险项" prop="mes" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.mes">{{ scope.row.mes }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="'操作'"
          width="160"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
            type="primary"
            plain
            size="mini"
            @click="handleCreate(scope.row)"
            >查看报告</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else style="margin-top:120px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-size="listQuery.limit"
        layout="total, prev, pager, next"
        :total="total"
        v-if="total>0"
      ></el-pagination>
    </div>

  <el-dialog
  class="dialog-mini"
  width="1000px"
  title="个人健康分析"
  top="10vh"
  v-if="showInfoDlog"
  :visible.sync="showInfoDlog"
  >
    <personalAnalysis></personalAnalysis>
  </el-dialog>
</div>
</template>
<script>
import * as evaluation from '@/api/evaluation/index';
import personalAnalysis from './component/personalAnalysis.vue';
export default {
  components: {
    personalAnalysis
  },
  data() {
    return {
      labledata: [
        { name: '全部', id: 0 },
        { name: '未开始', id: 1 },
        { name: '进行中', id: 2 },
        { name: '已结束', id: 3 },
        { name: '自测记录', id: 4 },
      ],
      lableindex: 0,
      total: 0,
      voteData: [],
      listQuery: {
        // 查询条件
        page: 1,
        limit: 10,
        userId: Number(this.$store.state.User.ids),
      },
      topicId: null,
      planId: null,
      showInfoDlog: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 查看报告
    handleCreate(row) {
      this.topicId = row.topic_id;
      this.planId = row.plan_id;
      window.open('/healthReport?id='+this.planId);
    },
    lableArea(index, item) {
      this.listQuery.type = item.id;
      this.lableindex = index;
      this.getList();
    },
    getList(){
      this.voteData = [];
      this.total = 0;
      if(this.lableindex === 4){
        let para = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          userId: Number(this.$store.state.User.ids),
        };
        evaluation.getAutoHealthyTestApi(para).then(response=>{
          this.voteData = response.data;
          this.total = response.count;
        })
        return false
      }
      evaluation.getMyTaskEvaluationApi(this.listQuery).then((response) => {
        this.voteData = response.data;
        this.total = response.count;
      });
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    //查看分析
    seeHealthFx(row){
      this.showInfoDlog = true;
    }
  },
};
</script>
<style scoped>
.centerbox {
  background-color: #f5f7fa;
  padding: 20px 40px 0 40px;
  color: #333;
  width: 1000px;
  margin: 0 auto;
}
.centertxt {
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  padding: 20px 0;
}
.centertxtlistt {
  background-color: #fff;
  border-radius: 5px;
  padding: 20px 0;
}
.centerheader {
  font-size: 48px;
  padding-top: 80px;
  margin-bottom: 10px;
  font-weight: bold;
}
.centerboxad {
  padding: 0 40px;
}
.centerheadercp {
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: bold;
  padding-left: 30px;
  text-align: center;
}
.centerheadetxt {
  font-size: 16px;
  margin-top: 20px;
}
.boderd {
  border-bottom: 2px dashed #f2f2f2;
  margin: 20px 0;
}
.centerheadercpbg {
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: bold;
  padding-left: 30px;
  text-align: center;
}

.centerborder {
  display: block;
  height: 0.5px;
  width: 850px;
  background: #000;
  margin: 0 auto;
  margin-top: 5px;
}
.rsulttxt {
  width: 830px;
  margin: 0 auto;
  font-size: 16px;
  color: #333;
}
.centsr {
  line-height: 28px;
  margin-top: 15px;
}

.evalus {
  /* width: 925px; */
  width: 100%;
  padding-bottom: 10px;
}

.playModel{
  box-sizing: border-box;
  padding: 20px 10px 10px 10px;
  border-bottom: 1px solid #f2f2f2;
}

.heightlight {
  color: #409eff !important;
}
.header {
  width: 923px;
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  padding-top: 0px;
}

.nav {
  border-radius: 10px;
  margin: 0 10px 50px 40px;
}

.navfirst {
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 10px;
}

.navsecond {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.navsecondbox {
  display: flex;
  align-items: center;
  flex: 1;
}
.nacsecodtxt {
  display: flex;
  font-size: 14px;
  margin-top: 15px;
}
.navthirt {
  padding-top: 10px;
  text-align: center;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.colorsi {
  color: #7f7f7f;
}
.navselef {
  width: 210px;
}
.widthber {
  width: 240px;
}
.borderbgc {
  padding: 3px 10px;
  border-radius: 10px;

  color: #fff;
  text-align: center;
  line-height: 19px;
  font-size: 12px;
}
.borderbgcgre {
  background-color: #70b603;
}
.borderbgcyel {
  background-color: #f59a23;
}
.borderbgcaa {
  background-color: #aaa;
}
.counselorbox {
  display: flex;
  padding: 40px 0;
  justify-content: center;
}
.counselorimgbox {
  text-align: center;
  font-size: 16px;
}
.counselorimg {
  height: 115px;
  width: 115px;
  border-radius: 50%;
  margin: 0 10px;
  margin-bottom: 15px;
}
</style>